<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="28"
    viewBox="0 0 34 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.6439 0.716129C31.0689 1.12258 32.1939 2.28387 32.5689 3.75484C33.2627 6.42581 33.2627 12 33.2627 12C33.2627 12 33.2627 17.5742 32.5877 20.2452C32.1939 21.7355 31.0877 22.8968 29.6627 23.2839C27.0752 24 16.7627 24 16.7627 24C16.7627 24 6.4502 24 3.88145 23.2839C2.45645 22.8774 1.33145 21.7161 0.956445 20.2452C0.262695 17.5742 0.262695 12 0.262695 12C0.262695 12 0.262695 6.42581 0.937695 3.75484C1.33145 2.26452 2.4377 1.10323 3.8627 0.716129C6.4502 0 16.7627 0 16.7627 0C16.7627 0 27.0752 0 29.6439 0.716129ZM22.0127 11.9999L13.3877 17.0709V6.92896L22.0127 11.9999Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconYoutube',
};
</script>
